import {
  Grid,
  TextField,
  InputAdornment,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { cepMask, TextMaskCustom } from "../utils/masks";
import { compactHelperFieldStyle, FieldLabel, SectionTitle } from "./profileFormStyles";

const AddressSection = ({
  formData,
  errors,
  handleChange,
  handleCEPBlur,
}) => {
  return (
    <Grid container columnSpacing={2} rowSpacing={2.25} sx={{ mt: 2 }}>
      <Grid item xs={12}>
        <SectionTitle>Endereço</SectionTitle>
      </Grid>

      <Grid item xs={12} md={4}>
        <FieldLabel>CEP *</FieldLabel>
        <TextField
          fullWidth
          required
          name="zipcode"
          error={!!errors.zipcode}
          helperText={errors.zipcode}
          value={formData.zipcode}
          onChange={handleChange}
          onBlur={handleCEPBlur}
          sx={compactHelperFieldStyle}
          InputProps={{
            inputComponent: TextMaskCustom,
            inputProps: { mask: cepMask },
            endAdornment: (
              <InputAdornment position="end">
                <Search fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12} md={8}>
        <FieldLabel>Rua *</FieldLabel>
        <TextField
          fullWidth
          required
          name="street"
          error={!!errors.street}
          helperText={errors.street}
          value={formData.street}
          onChange={handleChange}
          sx={compactHelperFieldStyle}
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <FieldLabel>Nº *</FieldLabel>
        <TextField
          fullWidth
          required
          name="number"
          error={!!errors.number}
          helperText={errors.number}
          value={formData.number}
          onChange={handleChange}
          sx={compactHelperFieldStyle}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <FieldLabel>Bairro *</FieldLabel>
        <TextField
          fullWidth
          required
          name="neighborhood"
          error={!!errors.neighborhood}
          helperText={errors.neighborhood}
          value={formData.neighborhood}
          onChange={handleChange}
          sx={compactHelperFieldStyle}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <FieldLabel>Cidade *</FieldLabel>
        <TextField
          fullWidth
          required
          name="city"
          error={!!errors.city}
          helperText={errors.city}
          value={formData.city}
          onChange={handleChange}
          sx={compactHelperFieldStyle}
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <FieldLabel>UF *</FieldLabel>
        <TextField
          fullWidth
          required
          name="state"
          error={!!errors.state}
          helperText={errors.state}
          value={formData.state}
          onChange={(e) => {
            const value = e.target.value.toUpperCase();
            handleChange({
              target: {
                name: "state",
                value: value.slice(0, 2),
              },
            });
          }}
          inputProps={{ maxLength: 2 }}
          sx={compactHelperFieldStyle}
        />
      </Grid>
    </Grid>
  );
};

export default AddressSection;
